import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output } from '@angular/core';
import { ButtonTypeEnum, DSButtonsComponent } from '@dch/pxs-angular-design-system/src/lib/buttons';
import { NgIf, NgClass } from '@angular/common';

var MessageBoxTypesEnum;
(function (MessageBoxTypesEnum) {
    MessageBoxTypesEnum[MessageBoxTypesEnum["Success"] = 0] = "Success";
    MessageBoxTypesEnum[MessageBoxTypesEnum["Error"] = 1] = "Error";
    MessageBoxTypesEnum[MessageBoxTypesEnum["Warning"] = 2] = "Warning";
    MessageBoxTypesEnum[MessageBoxTypesEnum["Congratulation"] = 3] = "Congratulation";
    MessageBoxTypesEnum[MessageBoxTypesEnum["Information"] = 4] = "Information";
    MessageBoxTypesEnum[MessageBoxTypesEnum["OnGoing"] = 5] = "OnGoing";
})(MessageBoxTypesEnum || (MessageBoxTypesEnum = {}));

// import { designClassesDictionary } from '@dch/pxs-angular-design-system/src/lib/external-dictionnary';
const designClassesDictionary = {
    text: {},
    grid: {
        row: '',
        column: '',
    },
    margin: {
        right: (size) => 'rs-margin-right' + size,
    },
    messageBox: {
        main: 'rs-msgbox',
        title: 'rs-msgbox-title',
        content: 'rs-msgbox-content',
        icon: 'rs-msgbox-icon',
        close: 'rs-msgbox-close',
        closeButton: 'rs-link-action rs-link-action-close close',
    },
};
class DSMessageBoxComponent {
    icon = '';
    class = '';
    forwardText = null;
    backwardText = null;
    showCross = true;
    closeMessageBoxTranslation = 'Close the message box';
    isNegative = false;
    cypressTag = '';
    forwardEmitter = new EventEmitter();
    backwardEmitter = new EventEmitter();
    crossEmitter = new EventEmitter();
    specificIcon = null;
    set messageType(type) {
        this.icon = this.getIcon(type);
        this.class = this.getClass(type);
    }
    getClass(type) {
        let selectedClass = '';
        switch (type) {
            case MessageBoxTypesEnum.Congratulation:
            case MessageBoxTypesEnum.Success:
                selectedClass = 'rs-msgbox-success';
                break;
            case MessageBoxTypesEnum.Error:
                selectedClass = 'rs-msgbox-error';
                break;
            case MessageBoxTypesEnum.Warning:
                selectedClass = 'rs-msgbox-warning';
                break;
            case MessageBoxTypesEnum.OnGoing:
                selectedClass = 'rs-msgbox-ongoing';
                break;
        }
        if (this.isNegative) {
            selectedClass += ' rs-msgbox-neg';
        }
        return selectedClass;
    }
    getIcon(type) {
        if (this.specificIcon) {
            return this.specificIcon;
        }
        switch (type) {
            case MessageBoxTypesEnum.Congratulation:
                return 'icon-Congratulations-box';
            case MessageBoxTypesEnum.Success:
                return 'icon-Validation-box';
            case MessageBoxTypesEnum.Error:
                return 'icon-Error-box';
            case MessageBoxTypesEnum.Warning:
                return 'icon-Warning-box';
            case MessageBoxTypesEnum.Information:
                return 'icon-Information-box';
            case MessageBoxTypesEnum.OnGoing:
                return 'icon-Status-ongoing';
        }
    }
    designClassesDictionary = designClassesDictionary;
    ButtonTypeEnum = ButtonTypeEnum;
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.4", ngImport: i0, type: DSMessageBoxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.4", type: DSMessageBoxComponent, isStandalone: true, selector: "lib-generic-message-box, ds-message-box", inputs: { forwardText: "forwardText", backwardText: "backwardText", showCross: "showCross", closeMessageBoxTranslation: "closeMessageBoxTranslation", isNegative: "isNegative", cypressTag: "cypressTag", specificIcon: "specificIcon", messageType: "messageType" }, outputs: { forwardEmitter: "forwardEmitter", backwardEmitter: "backwardEmitter", crossEmitter: "crossEmitter" }, ngImport: i0, template: "<div\n\t[ngClass]=\"[designClassesDictionary.messageBox.main, class]\"\n\tdata-alert\n\tdata-ng-non-bindable\n\taria-live=\"assertive\"\n\trole=\"alertdialog\"\n\t[attr.data-cy]=\"'messageBox-' + cypressTag\"\n>\n\t<div [ngClass]=\"designClassesDictionary.messageBox.title\">\n\t\t<ng-content select=\"[Title]\"></ng-content>\n\t</div>\n\t<div [ngClass]=\"designClassesDictionary.messageBox.content\">\n\t\t<ng-content select=\"[Content]\"></ng-content>\n\t\t<lib-button\n\t\t\t*ngIf=\"backwardText !== null\"\n\t\t\t[buttonConfig]=\"{\n\t\t\t\tlabel: backwardText,\n\t\t\t\tbuttonType: [ButtonTypeEnum.ThirdLeftIcon]\n\t\t\t}\"\n\t\t\t(clicked)=\"backwardEmitter.emit()\"\n\t\t\t[ngClass]=\"backwardText !== null && forwardText !== null ? designClassesDictionary.margin.right(2) : ''\"\n\t\t>\n\t\t</lib-button>\n\t\t<lib-button\n\t\t\t*ngIf=\"forwardText !== null\"\n\t\t\t[buttonConfig]=\"{\n\t\t\t\tlabel: forwardText,\n\t\t\t\tbuttonType: [ButtonTypeEnum.ThirdRightIcon]\n\t\t\t}\"\n\t\t\t(clicked)=\"forwardEmitter.emit()\"\n\t\t>\n\t\t</lib-button>\n\t</div>\n\t<div [ngClass]=\"designClassesDictionary.messageBox.icon\">\n\t\t<i class=\"{{ icon }}\" aria-hidden=\"true\"></i>\n\t</div>\n\t<div *ngIf=\"showCross\" [ngClass]=\"designClassesDictionary.messageBox.close\">\n\t\t<a\n\t\t\thref=\"javascript:void(0)\"\n\t\t\t(click)=\"crossEmitter.emit()\"\n\t\t\t[ngClass]=\"designClassesDictionary.messageBox.closeButton\"\n\t\t\ttabindex=\"0\"\n\t\t\taria-label=\"Close\"\n\t\t\trole=\"button\"\n\t\t>\n\t\t\t<span class=\"rs-action-link-icon\" [title]=\"closeMessageBoxTranslation\">\n\t\t\t\t<span class=\"show-for-sr\">{{ closeMessageBoxTranslation }}</span>\n\t\t\t</span>\n\t\t</a>\n\t</div>\n</div>\n", dependencies: [{ kind: "component", type: DSButtonsComponent, selector: "lib-button, ds-button", inputs: ["buttonConfig", "disabled"], outputs: ["clicked"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.4", ngImport: i0, type: DSMessageBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-generic-message-box, ds-message-box', changeDetection: ChangeDetectionStrategy.OnPush, imports: [DSButtonsComponent, NgIf, NgClass], template: "<div\n\t[ngClass]=\"[designClassesDictionary.messageBox.main, class]\"\n\tdata-alert\n\tdata-ng-non-bindable\n\taria-live=\"assertive\"\n\trole=\"alertdialog\"\n\t[attr.data-cy]=\"'messageBox-' + cypressTag\"\n>\n\t<div [ngClass]=\"designClassesDictionary.messageBox.title\">\n\t\t<ng-content select=\"[Title]\"></ng-content>\n\t</div>\n\t<div [ngClass]=\"designClassesDictionary.messageBox.content\">\n\t\t<ng-content select=\"[Content]\"></ng-content>\n\t\t<lib-button\n\t\t\t*ngIf=\"backwardText !== null\"\n\t\t\t[buttonConfig]=\"{\n\t\t\t\tlabel: backwardText,\n\t\t\t\tbuttonType: [ButtonTypeEnum.ThirdLeftIcon]\n\t\t\t}\"\n\t\t\t(clicked)=\"backwardEmitter.emit()\"\n\t\t\t[ngClass]=\"backwardText !== null && forwardText !== null ? designClassesDictionary.margin.right(2) : ''\"\n\t\t>\n\t\t</lib-button>\n\t\t<lib-button\n\t\t\t*ngIf=\"forwardText !== null\"\n\t\t\t[buttonConfig]=\"{\n\t\t\t\tlabel: forwardText,\n\t\t\t\tbuttonType: [ButtonTypeEnum.ThirdRightIcon]\n\t\t\t}\"\n\t\t\t(clicked)=\"forwardEmitter.emit()\"\n\t\t>\n\t\t</lib-button>\n\t</div>\n\t<div [ngClass]=\"designClassesDictionary.messageBox.icon\">\n\t\t<i class=\"{{ icon }}\" aria-hidden=\"true\"></i>\n\t</div>\n\t<div *ngIf=\"showCross\" [ngClass]=\"designClassesDictionary.messageBox.close\">\n\t\t<a\n\t\t\thref=\"javascript:void(0)\"\n\t\t\t(click)=\"crossEmitter.emit()\"\n\t\t\t[ngClass]=\"designClassesDictionary.messageBox.closeButton\"\n\t\t\ttabindex=\"0\"\n\t\t\taria-label=\"Close\"\n\t\t\trole=\"button\"\n\t\t>\n\t\t\t<span class=\"rs-action-link-icon\" [title]=\"closeMessageBoxTranslation\">\n\t\t\t\t<span class=\"show-for-sr\">{{ closeMessageBoxTranslation }}</span>\n\t\t\t</span>\n\t\t</a>\n\t</div>\n</div>\n" }]
        }], propDecorators: { forwardText: [{
                type: Input
            }], backwardText: [{
                type: Input
            }], showCross: [{
                type: Input
            }], closeMessageBoxTranslation: [{
                type: Input
            }], isNegative: [{
                type: Input
            }], cypressTag: [{
                type: Input
            }], forwardEmitter: [{
                type: Output
            }], backwardEmitter: [{
                type: Output
            }], crossEmitter: [{
                type: Output
            }], specificIcon: [{
                type: Input
            }], messageType: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { DSMessageBoxComponent, MessageBoxTypesEnum, designClassesDictionary };
